// extracted by mini-css-extract-plugin
module.exports = {"button":"DeleteButton_button__igG7I","icon":"DeleteButton_icon__3Ba4a"};